import React, { useState, useEffect } from 'react';
import './Header.css';
import logoImg from './pictures/MBC logo.png';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(prev => !prev);
  const closeMenu = () => setMenuOpen(false);

  // Scroll to top when clicking logo / brand
  const handleHomeClick = (e) => {
    e.preventDefault();
    closeMenu();
    window.scrollTo({ top: 0, behavior: 'smooth' }); // scroll to Home/top [web:40]
  };

  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }
    return () => document.body.classList.remove('menu-open');
  }, [menuOpen]);

  return (
    <header className="site-header">
      <div className="header-container">
        {/* clickable logo + name = Home */}
        <button className="home-link" onClick={handleHomeClick} aria-label="Go to top">
          <div className="logo-section">
            <img
              src={logoImg}
              alt="MAA BHAGWATI CONSTRUCTION"
              className="logo-img"
            />
            <span className="brand">
              MAA BHAGWATI<br />CONSTRUCTION
            </span>
          </div>
        </button>

        <button
          className={`mobile-menu-toggle ${menuOpen ? 'open' : ''}`}
          onClick={toggleMenu}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div
          className={`nav-overlay ${menuOpen ? 'open' : ''}`}
          onClick={closeMenu}
        />

        <nav className={`nav ${menuOpen ? 'open' : ''}`}>
          <a href="#top" onClick={handleHomeClick}>Home</a>
          <a href="#about" onClick={closeMenu}>About</a>
          <a href="#services" onClick={closeMenu}>Services</a>
          <a href="#projects" onClick={closeMenu}>Projects</a>
          <a href="#contact" onClick={closeMenu}>Contact</a>
        </nav>
      </div>
    </header>
  );
}
